<template>
  <DiscountPassVerification
    :validation-params="validationParams"
    :show-form-level-error-message="true"
    :disable-submit="(!form.selfCert || !form.agreeToProve)"
    v-on="$listeners"
  >
    <div
      slot="summary"
      class="info"
    >
      <h2 class="legend">
        Verify Eligibility
      </h2>
      <p>
        Per the United States federal government's <ExternalLink
          href="https://beta.ada.gov/topics/intro-to-ada/"
          text="ADA.gov website"
        />
        &nbsp;a person with a disability is someone who:
      </p>
      <ul class="bulleted">
        <li>
          has a physical or mental impairment that substantially limits one or more major life activities,
        </li>
        <li>
          has a history or record of such an impairment (such as cancer that is in remission), or
        </li>
        <li>
          is perceived by others as having such an impairment (such as a person who has scars from a severe burn).
        </li>
      </ul>
      <p>If a person falls into any of these categories, the ADA protects them. Because the ADA is a law, and not a benefit program, you do not need to apply for coverage.</p>
    </div>
    <template slot="eligibility-fields">
      <fieldset class="fieldset">
        <legend class="legend legend--smaller">
          Self-certify disability status
        </legend>
        <div class="checkbox">
          <input
            id="disability-self-cert"
            v-model="form.selfCert"
            type="checkbox"
            class="checkbox__input"
            required
          >
          <label
            for="disability-self-cert"
            class="checkbox__label"
          >Per the ADA definition provided above, I am disabled.</label>
        </div>
        <div class="checkbox">
          <input
            id="disability-proof"
            v-model="form.agreeToProve"
            type="checkbox"
            class="checkbox__input"
            required
          >
          <label
            for="disability-proof"
            class="checkbox__label"
          >I understand that in the future, I may be asked to provide proof of my disability. I agree that if I do not provide proof of disability, my benefits may be terminated from the Reduced Fare program.</label>
        </div>
      </fieldset>
    </template>
  </DiscountPassVerification>
</template>

<script>
import DiscountPassVerification from '../DiscountPassVerification.vue';
import ExternalLink from '../../ExternalLink.vue';

export default {
  components: { DiscountPassVerification, ExternalLink },
  data() {
    return {
      form: {
        selfCert: false,
        agreeToProve: false,
      },
      validationParams: {
        validationType: 'self_certify',
      },
    };
  },
};
</script>
